import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface User {
  id: number;
  name: string;
  messages: Message[];
}

interface Message {
  id: number;
  text: string;
  sender: "user" | "other";
  timestamp: string;
  isRead: boolean;
}

interface ChatProps {
  messages: Message[];
  onSendMessage: (
    text: string,
    mediaUrl?: string,
    mediaType?: "image" | "audio"
  ) => void;
  onMarkAsRead: (id: number) => void;
  onEditMessage: (id: number, newText: string) => void;
  onDeleteMessage: (id: number) => void;
}

const Chat: React.FC<ChatProps> = ({
  onMarkAsRead,
  onEditMessage,
  onDeleteMessage,
}) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [editingMessageId, setEditingMessageId] = useState<number | null>(null);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [users, setUsers] = useState<User[]>([
    {
      id: 1,
      name: "امیر ایمن پور",
      messages: [
        {
          id: 1,
          text: "سلام و وقت بخیر!",
          sender: "user",
          timestamp: "2024-12-19 10:00",
          isRead: true,
        },
        {
          id: 2,
          text: "چطوری؟",
          sender: "other",
          timestamp: "2024-12-19 10:02",
          isRead: false,
        },
      ],
    },
    {
      id: 2,
      name: "کاربر",
      messages: [
        {
          id: 3,
          text: "سلام!",
          sender: "user",
          timestamp: "2024-12-19 11:00",
          isRead: true,
        },
        {
          id: 4,
          text: "خوبی؟",
          sender: "other",
          timestamp: "2024-12-19 11:05",
          isRead: false,
        },
      ],
    },
  ]);

  const handleUserSelect = (user: User) => {
    setSelectedUser(user);
  };

  const handleSendMessage = () => {
    if (inputValue.trim() === "") return;
  
    if (editingMessageId !== null) {
      onEditMessage(editingMessageId, inputValue);
      const updatedUsers = users.map((user) =>
        user.id === selectedUser?.id
          ? {
              ...user,
              messages: user.messages.map((message) =>
                message.id === editingMessageId
                  ? { ...message, text: inputValue }
                  : message
              ),
            }
          : user
      );
      setUsers(updatedUsers);
      const updatedSelectedUser = updatedUsers.find(
        (user) => user.id === selectedUser?.id
      );
      if (updatedSelectedUser) setSelectedUser(updatedSelectedUser);
      setEditingMessageId(null);
    } else {
      const newMessage: Message = {
        id: Date.now(),
        text: inputValue,
        sender: "user",
        timestamp: new Date().toLocaleString(),
        isRead: false,
      };
  
      const updatedUsers = users.map((user) =>
        user.id === selectedUser?.id
          ? { ...user, messages: [...user.messages, newMessage] }
          : user
      );
      setUsers(updatedUsers);
      const updatedSelectedUser = updatedUsers.find(
        (user) => user.id === selectedUser?.id
      );
      if (updatedSelectedUser) setSelectedUser(updatedSelectedUser);
    }
  
    setInputValue("");
  };
  

  const handleEditMessage = (messageId: number, currentText: string) => {
    setEditingMessageId(messageId);
    setInputValue(currentText);
  };

  const handleDeleteMessage = (messageId: number) => {
    onDeleteMessage(messageId);
    const updatedUsers = users.map((user) =>
      user.id === selectedUser?.id
        ? {
            ...user,
            messages: user.messages.filter(
              (message) => message.id !== messageId
            ),
          }
        : user
    );
    setUsers(updatedUsers);
    const updatedSelectedUser = updatedUsers.find(
      (user) => user.id === selectedUser?.id
    );
    if (updatedSelectedUser) setSelectedUser(updatedSelectedUser);
  };
  
  return (
    <div style={{ display: "flex", height: "90vh" , padding:4}}>
      <div
        style={{
          width: "30%",
          padding: "10px",
          backgroundColor: "#f0f0f0",
          overflowY: "auto",
        }}
      >
        <h3>انتخاب کاربرها</h3>
        {users.map((user) => (
  <div
  key={user.id}
  onClick={() => handleUserSelect(user)}
  style={{
    padding: "10px",
    backgroundColor: selectedUser?.id === user.id ? "gray" : "#fff",
    color: selectedUser?.id === user.id ? "#fff" : "#000", // برای تغییر رنگ متن در صورت انتخاب
    borderRadius: "5px",
    marginBottom: "10px",
    cursor: "pointer",
  }}
>
  {user.name}
</div>
        ))}
      </div>

      <div style={{ width: "70%", display: "flex", flexDirection: "column" }}>
        {selectedUser ? (
          <>
            <div
              style={{
                flex: 1,
                padding: "10px",
                overflowY: "auto",
                backgroundColor: "#f7f7f8",
              }}
            >
              {selectedUser.messages.map((message) => (
                <div
                  key={message.id}
                  style={{
                    padding: "10px 15px",
                    margin: "10px 0",
                    borderRadius: "20px",
                    maxWidth: "70%",
                    backgroundColor:
                      message.sender === "user" ? "#d5e8ed" : "#ddf7cd",
                    marginLeft: message.sender === "user" ? "auto" : "0",
                    marginRight: message.sender === "user" ? "0" : "auto",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {message.text && (
                    <p style={{ margin: "0", wordBreak: "break-word" }}>
                      {message.text}
                    </p>
                  )}
                                    {message.sender === "user" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "5px",
                      }}
                    >
                      <EditIcon
                        style={{
                          fontSize: "18px",
                          cursor: "pointer",
                          color: "#00387C",
                        }}
                        onClick={() =>
                          handleEditMessage(message.id, message.text)
                        }
                      />
                      <DeleteIcon
                        style={{
                          fontSize: "18px",
                          cursor: "pointer",
                          color: "#E02B20",
                        }}
                        onClick={() => handleDeleteMessage(message.id)}
                      />
                    </div>
                  )}
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#888",
                      alignSelf:
                        message.sender === "user" ? "flex-end" : "flex-start",
                    }}
                  >
                    {message.timestamp}
                  </span>

                </div>
              ))}
            </div>

            <div
              style={{
                display: "flex",
                borderTop: "1px solid #ccc",
                padding: "8px",
                background: "#fff",
              }}
            >
              <input
                type="text"
                placeholder="پیام خود را وارد کنید..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{
                  flex: 1,
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "20px",
                  marginLeft: "5px",
                  fontSize: "14px",
                }}
              />
              <button
                onClick={handleSendMessage}
                style={{
                  marginLeft: "8px",
                  padding: "8px 16px",
                  backgroundColor: "#00387C",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                {editingMessageId ? "ذخیره تغییرات" : "ارسال پیام"}
              </button>
            </div>
          </>
        ) : (
          <div style={{ padding: "20px", textAlign: "center" }}>
            <h3>لطفاً یک کاربر را انتخاب کنید</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
